import { render, staticRenderFns } from "./SamInfoBlock.vue?vue&type=template&id=5cbdcd0d&scoped=true&shadow"
import script from "./SamInfoBlock.vue?vue&type=script&lang=js&shadow"
export * from "./SamInfoBlock.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamInfoBlock.vue?vue&type=style&index=0&id=5cbdcd0d&prod&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5cbdcd0d",
  null
  ,true
)

export default component.exports